export default __webpack_public_path__ + "static/media/compare-support-green.742928407a86e2a8c4fad82848f1e976.svg";